import classNames from 'classnames';
import { FC } from 'react';
import ReactSkeleton, { SkeletonProps } from 'react-loading-skeleton';
import styles from './Skeleton.module.scss';

const Skeleton: FC<SkeletonProps> = (props) => {
    return (
        <ReactSkeleton
            {...props}
            className={classNames(
                props.className,
                styles['react-loading-skeleton'],
            )}
        />
    );
};

export default Skeleton;
